import React from 'react';
import { MapPin } from 'lucide-react';

export const ZoneIntervention = () => {
  const zones = [
    { ville: "Urrugne", type: "Siège" },
    { ville: "Bayonne", type: "Intervention" },
    { ville: "Biarritz", type: "Intervention" },
    { ville: "Anglet", type: "Intervention" },
    { ville: "Saint-Jean-de-Luz", type: "Intervention" },
    { ville: "Hendaye", type: "Intervention" },
    { ville: "Ciboure", type: "Intervention" },
    { ville: "Bidart", type: "Intervention" },
    { ville: "Guéthary", type: "Intervention" },
    { ville: "Ascain", type: "Intervention" },
    { ville: "Sare", type: "Intervention" },
    { ville: "Cambo-les-Bains", type: "Intervention" }
  ];

  return (
    <section className="py-20 bg-slate-900">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-500/20 backdrop-blur-sm border border-blue-400/30 rounded-full mb-4">
              <MapPin className="w-4 h-4 text-blue-400" />
              <span className="text-blue-300 text-sm font-medium">Pays Basque</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Zone d'Intervention
            </h2>
            <p className="text-xl text-slate-400">
              Électricien et Cordiste dans tout le Pays Basque
            </p>
          </div>

          <div className="bg-slate-800/50 backdrop-blur-sm border border-slate-700 rounded-2xl p-8 mb-8">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 bg-blue-500/20 rounded-xl flex items-center justify-center flex-shrink-0">
                <MapPin className="w-6 h-6 text-blue-400" />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white mb-2">Basé à Urrugne</h3>
                <p className="text-slate-300 leading-relaxed">
                  Mon entreprise <strong className="text-white">Alpielec</strong> est basée à <strong className="text-white">Urrugne</strong> et 
                  j'interviens dans tout le <strong className="text-white">Pays Basque</strong> pour vos travaux d'<strong className="text-white">électricité</strong> et 
                  vos <strong className="text-white">travaux en hauteur</strong>. Particuliers, professionnels et copropriétés bénéficient 
                  d'un service rapide et professionnel.
                </p>
              </div>
            </div>

            <div className="border-t border-slate-700 pt-6">
              <h4 className="text-lg font-semibold text-white mb-4">Villes couvertes :</h4>
              <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                {zones.map((zone, index) => (
                  <div
                    key={index}
                    className={`px-4 py-2 rounded-lg border transition-colors ${
                      zone.type === 'Siège'
                        ? 'bg-blue-500/20 border-blue-500/50 text-blue-300'
                        : 'bg-slate-700/30 border-slate-600 text-slate-300 hover:border-blue-500/30'
                    }`}
                  >
                    <div className="flex items-center gap-2">
                      {zone.type === 'Siège' && (
                        <MapPin className="w-4 h-4 flex-shrink-0" />
                      )}
                      <span className="text-sm font-medium">{zone.ville}</span>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-blue-600 to-blue-800 rounded-2xl p-8 text-center">
            <p className="text-xl text-white font-semibold mb-2">
              Votre commune n'est pas listée ?
            </p>
            <p className="text-blue-100 mb-4">
              Contactez-moi ! J'interviens dans toute la région pour des projets d'électricité et cordiste.
            </p>
            <a
              href="tel:0610952631"
              className="inline-flex items-center justify-center px-6 py-3 bg-white text-blue-600 rounded-lg font-semibold hover:bg-blue-50 transition-colors"
            >
              06 10 95 26 31
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
